<template>
  <h2 class="text-md font-bold text-blue-gray-700 mb-4">Settings</h2>
  
  <h3 class="text-sm font-semibold text-blue-gray-700 mb-2">Quality</h3>
  <div class="flex items-center mb-4">
    <Input v-model="quality" @input="emitChange" class="w-2/3" label="%" :is-invalid="invalidQuality" id="quality" />
  </div>

  <h3 class="text-sm font-semibold text-blue-gray-700 mb-2">Width</h3>
  <fieldset>
    <div v-for="(field, idx) in fields" :key="idx" class="flex items-center mb-3">
      <Input v-model="field.width" @input="emitChange" :is-invalid="invalidWidth[idx]" :id="`width_${idx}`" class="w-2/3" label="px" />
      <button
        type="button"
        v-if="idx > 0"
        class="rounded-full bg-teal-400 text-white w-6 h-6 ml-4 outline-none"
        @click="removeField(idx)"
      >
        -
      </button>
      <button
        type="button"
        v-if="idx === fields.length - 1"
        class="rounded-full bg-teal-400 text-white w-6 h-6 ml-4 outline-none disabled:bg-gray-200"
        @click="addField"
        :disabled="invalidWidth[idx] || fields.length >= 5"
      >
        +
      </button>
    </div>
  </fieldset>
</template>

<script>
import Input from './Input.vue'
export default {
  emits: ['change'],
  components: {
    Input
  },
  data() {
    return {
      quality: 80,
      fields: [
        {
          width: 1280
        }
      ]
    }
  },
  computed: {
    invalidQuality() {
      return this.quality > 100 || this.quality <= 0;
    },
    invalidWidth() {
      return this.fields.map(f => !(f.width > 0))
    }
  },
  methods: {
    addField() {
      if (this.fields.length < 5) {
        this.fields.push({
          width: null
        })
      }
    },
    removeField(idx) {
      this.fields.splice(idx, 1)
    },
    emitChange() {
      const widths = this.fields
        .reduce((acc, f) => {
          if (f.width > 0) {
            acc.push(f.width)
          }
          return acc;
        }, []);

      this.$emit('change', {
        quality: this.quality,
        widths: [...new Set(widths)]
      })
    }
  },
  mounted() {
    this.emitChange();
  }
}
</script>
